import React, { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { useSettings } from "@/context/SettingsContext";
import SEO from "@/components/SEO";

export default function About() {
  const s = useSettings();
  const [c, setC] = useState({});
  useEffect(() => { api.get("/pages/about").then(({ data }) => setC(data.content || {})).catch(() => {}); }, []);
  const blocks = [
    ["Who We Are", c.who_we_are],
    ["Our Purpose", c.our_purpose],
    ["Institutional Approach", c.institutional_approach],
    ["Public Accountability", c.public_accountability],
    ["Legal & Policy Intervention", c.legal_policy_intervention],
  ].filter(([, v]) => v);

  return (
    <div className="fade-in">
      <SEO title="About — National Public Service Trust" description={s.meta_description} canonical={`${window.location.origin}/about`} />
      <section className="border-b border-npst-line paper-texture">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="label-eyebrow text-npst-gold mb-3">About the Institution</div>
          <h1 className="font-serif text-4xl sm:text-6xl font-semibold text-npst-ink tracking-tight max-w-3xl">About National Public Service Trust</h1>
          <p className="mt-6 text-xl text-npst-inkSoft max-w-3xl leading-relaxed">{s.intro}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-16">
        {blocks.map(([title, body]) => (
          <div key={title} className="grid grid-cols-1 lg:grid-cols-12 gap-8 border-t border-npst-line pt-10">
            <div className="lg:col-span-3"><div className="label-eyebrow text-npst-gold">{title}</div></div>
            <div className="lg:col-span-9"><p className="font-serif text-2xl text-npst-ink leading-relaxed">{body}</p></div>
          </div>
        ))}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-npst-line border border-npst-line rounded-md overflow-hidden">
          {[["Registration Number", s.registration_number], ["Registered Office", s.address], ["Year of Establishment", s.established]].filter(([, v]) => v).map(([l, v]) => (
            <div key={l} className="bg-npst-bg p-7"><div className="label-eyebrow text-npst-gold mb-2">{l}</div><div className="text-npst-ink font-medium">{v}</div></div>
          ))}
        </div>
      </section>
    </div>
  );
}
